import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Ana Sayfa' },
    { path: '/about', label: 'Hakkımızda' },
    { path: '/attorneys', label: 'Avukatlarımız' },
    { path: '/practice-areas', label: 'Uzmanlık Alanları' },
    { path: '/legal-insights', label: 'Hukuki Görüşler' },
    { path: '/case-studies', label: 'Başarı Hikayeleri' },
    { path: '/contact', label: 'İletişim' },
  ];

  return (
    <motion.nav
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center space-x-3 group">
            {/* FP Monogram */}
            <div className="flex items-center justify-center w-10 h-10">
              <span
                className={`font-serif text-2xl font-bold leading-none transition-colors duration-300 ${
                  isScrolled ? 'text-navy-900' : 'text-white'
                }`}
                style={{ fontFamily: "'Playfair Display', serif", letterSpacing: '-0.02em' }}
              >
                FP
              </span>
            </div>
            {/* Divider */}
            <div
              className={`w-px h-8 transition-colors duration-300 ${
                isScrolled ? 'bg-gold-500' : 'bg-white/50'
              }`}
            ></div>
            {/* Full Name */}
            <div className="flex flex-col leading-tight">
              <span
                className={`font-sans text-sm font-semibold uppercase tracking-widest transition-colors duration-300 ${
                  isScrolled ? 'text-navy-900' : 'text-white'
                }`}
                style={{ letterSpacing: '0.12em' }}
              >
                FP Hukuk
              </span>
              <span
                className={`font-sans text-xs font-normal uppercase tracking-widest transition-colors duration-300 ${
                  isScrolled ? 'text-gold-500' : 'text-gold-400'
                }`}
                style={{ letterSpacing: '0.18em' }}
              >
                ve Danışmanlık
              </span>
            </div>
          </Link>

          <div className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-sans text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === link.path
                    ? isScrolled
                      ? 'text-navy-900'
                      : 'text-white'
                    : isScrolled
                    ? 'text-navy-700 hover:text-navy-900'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            <Link
              to="/contact"
              className={`px-6 py-3 rounded-md font-sans text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                isScrolled
                  ? 'bg-gold-500 text-white hover:bg-gold-600'
                  : 'bg-white text-navy-900 hover:bg-white/90'
              }`}
            >
              Danışmanlık Talep Edin
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`text-2xl ${
                isScrolled ? 'text-navy-900' : 'text-white'
              } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden bg-white border-t border-gray-200"
          >
            <div className="px-6 py-4 space-y-3">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`block py-2 font-sans text-sm font-medium cursor-pointer ${
                    location.pathname === link.path
                      ? 'text-navy-900'
                      : 'text-navy-700 hover:text-navy-900'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contact"
                onClick={() => setIsMobileMenuOpen(false)}
                className="block w-full px-6 py-3 bg-gold-500 text-white text-center rounded-md font-sans text-sm font-medium hover:bg-gold-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Danışmanlık Talep Edin
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.nav>
  );
};

export default Navbar;